/* src/app/components/doc-viewer-new/doc-viewer-bottom-right-bar/doc-note-panel/doc-note-panel.component.scss */
.note-list-item {
  margin-bottom: 8px;
  border-radius: 4px;
  padding: 0px 4px 0px 4px;
}
.note-list-item > div {
  padding: 3px;
  line-height: 20px;
}
.note-body-input {
  background: rgba(0, 0, 0, 0.01);
}
:host-context(.dark-theme) .note-body-input {
  background: rgba(255, 255, 255, 0.05);
}
.private {
  background-color: #ffffbb;
}
.public {
  background-color: #ffbbbb;
}
button {
  background: #FFF;
}
.icon {
  --fa-primary-color: #3949AB;
  --fa-secondary-color: #FFF;
  --fa-secondary-opacity: 1 ;
}
:host-context(.dark-theme) .right-panel-container {
  background: #2E2E2E;
}
:host-context(.dark-theme) .public {
  color: black;
}
:host-context(.dark-theme) .private {
  color: black;
}
:host-context(.dark-theme) button {
  background: #000;
}
:host-context(.dark-theme) .icon {
  --fa-primary-color: #737373;
  --fa-secondary-color: #FFC107;
}
/*# sourceMappingURL=doc-note-panel.component.css.map */
